import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const RFQModal = ({ isOpen, onClose, service }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    urgency: 'medium',
    budget: '',
    requirements: ''
  });

  const urgencyOptions = [
    { value: 'low', label: 'Low - Within 3 months' },
    { value: 'medium', label: 'Medium - Within 1 month' },
    { value: 'high', label: 'High - Within 2 weeks' },
    { value: 'urgent', label: 'Urgent - ASAP' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    // In a real app, this would submit to an API
    console.log('RFQ submitted:', { service: service?.id, ...formData });
    onClose();
    navigate('/rfq-management');
  };

  const handleFullForm = () => {
    onClose();
    navigate(`/rfq-request-form?service=${service?.id}`);
  };

  if (!isOpen || !service) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-card border border-border rounded-lg shadow-elevated w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Quick RFQ Request</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Request a quote for: {service?.title}
            </p>
          </div>
          <Button variant="ghost" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Company Name"
              type="text"
              required
              value={formData?.companyName}
              onChange={(e) => handleInputChange('companyName', e?.target?.value)}
              placeholder="Your company name"
            />
            <Input
              label="Contact Person"
              type="text"
              required
              value={formData?.contactPerson}
              onChange={(e) => handleInputChange('contactPerson', e?.target?.value)}
              placeholder="Your full name"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Email Address"
              type="email"
              required
              value={formData?.email}
              onChange={(e) => handleInputChange('email', e?.target?.value)}
              placeholder="your.email@company.com"
            />
            <Input
              label="Phone Number"
              type="tel"
              required
              value={formData?.phone}
              onChange={(e) => handleInputChange('phone', e?.target?.value)}
              placeholder="+256 XXX XXX XXX"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="Project Urgency"
              options={urgencyOptions}
              value={formData?.urgency}
              onChange={(value) => handleInputChange('urgency', value)}
            />
            <Input
              label="Estimated Budget (UGX)"
              type="text"
              value={formData?.budget}
              onChange={(e) => handleInputChange('budget', e?.target?.value)}
              placeholder="e.g., 5,000,000 - 10,000,000"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Brief Requirements
            </label>
            <textarea
              className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
              rows={4}
              value={formData?.requirements}
              onChange={(e) => handleInputChange('requirements', e?.target?.value)}
              placeholder="Please describe your specific requirements and any additional details..."
            />
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={handleFullForm}
              className="flex-1"
            >
              <Icon name="FileText" size={16} className="mr-2" />
              Detailed RFQ Form
            </Button>
            <Button type="submit" className="flex-1">
              <Icon name="Send" size={16} className="mr-2" />
              Submit Quick RFQ
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RFQModal;